export default __webpack_public_path__ + "static/media/IconNavAvatar.2938c951.svg";